// A missing current score must never fall back to a historical score or zero.
export function riskScore(order) {
  if ((order.type || order.order_type) === 'online' || order.risk_level === 'not_applicable') return null;
  const assessment = order.risk_assessment;
  const value = assessment ? (Object.prototype.hasOwnProperty.call(assessment, 'risk_score') ? assessment.risk_score : assessment.behavior_score) : order.risk_score;
  if (value === null || value === undefined || (typeof value !== 'number' && typeof value !== 'string') || String(value).trim() === '') return null;
  const score = Number(value);
  return Number.isInteger(score) && score >= 0 && score <= 100 ? score : null;
}

export function riskScoreTone(score) {
  if (score === null) return undefined;
  return score >= 60 ? 'critical' : score >= 15 ? 'warning' : undefined;
}
